if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          if (!entries[0].isIntersecting) return;
          obs.unobserve(this);
          this.loadRecommendations();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      observer.observe(this);
    }

    loadRecommendations() {
      fetch(
        `${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}`
      )
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
